'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = require('conversations-schema/records/Message');

var _Message2 = _interopRequireDefault(_Message);

var _Responder = require('conversations-schema/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _immutable = require('immutable');

var _LauncherTypes = require('conversations-schema/constants/LauncherTypes');

var _LauncherTypes2 = _interopRequireDefault(_LauncherTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON = _LauncherTypes2.default.ICON;
exports.default = (0, _immutable.Record)({
  message: (0, _Message2.default)(),
  responder: (0, _Responder2.default)(),
  responders: null,
  aboutMe: null,
  jobTitle: null,
  launcherType: ICON,
  coloring: (0, _ColoringRecord2.default)(),
  meetingsLinkText: null,
  meetingsLinkUrl: null,
  customAwayMessage: null,
  showingHsBranding: false,
  sessionId: null,
  hasVisitorEmail: false,
  agentsRestrictedToMaxConcurrentChats: null,
  online: null
}, 'WidgetData');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/WidgetData.js
// module id = 41
// module chunks = 0 1